// extracted by mini-css-extract-plugin
export default {"container":"StatisticsPage_container__2cr6a","loaderContainer":"StatisticsPage_loaderContainer__Sq0Uh"};